import React, { useCallback } from 'react';
import { Dropdown } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';
import { NotificationTemplateFragment } from '@/graphql/generated/graphql';
import { DownOutlined } from '@ant-design/icons';

type Props = {
  onSelectTemplate?: (variable: string) => void;
  notificationTemplates?: NotificationTemplateFragment[];
};

const TemplateSelector: React.FC<Props> = ({ onSelectTemplate, notificationTemplates = [] }) => {
  const handleMenuClick = useCallback(
    (e: MenuInfo) => {
      onSelectTemplate?.(e.key);
    },
    [onSelectTemplate]
  );

  return (
    <Dropdown.Button
      type="primary"
      menu={{
        items: notificationTemplates?.map((notification) => {
          return {
            key: notification.id,
            label: notification.name,
          };
        }),
        onClick: handleMenuClick,
      }}
      icon={<DownOutlined />}
    >
      Apply Template
    </Dropdown.Button>
  );
};

export default TemplateSelector;
